<script setup lang="ts">
import type {PropType} from "vue";

const props = defineProps({
  errors: {
    type: Object as PropType<{name?: null|string, last_name?: null|string}>,
    default: {
      name: '',
      last_name: ''
    }
  },
  userData: {
    type: Object as PropType<{first_name: string, last_name: string}>,
    default: {
      first_name: '',
      last_name: ''
    }
  }
})
const emit = defineEmits(['handleUpdateProfile'])
const handleUpdateProfile = () => {
  emit('handleUpdateProfile')
}
</script>

<template>
  <div class="flex xs:flex-row flex-col md:gap-6 gap-3 w-full">
    <div class="mt-auto w-full">
      <p v-if="errors.name" class="error-text">{{errors.name}}</p>
      <UIInput v-model="userData.first_name" :placeholder="$t('input_forms.field.name.placeholder')" class="rounded-lg min-w-full border-secondary-600"/>
    </div>
    <div class="mt-auto w-full">
      <p v-if="errors.last_name" class="error-text">{{errors.last_name}}</p>
      <UIInput v-model="userData.last_name" :placeholder="$t('input_forms.field.last_name.placeholder')" class="rounded-lg min-w-full border-secondary-600"/>
    </div>
  </div>
  <UIBtn
      @click="handleUpdateProfile"
      color="green"
      class="w-fit ml-auto"
  >
    {{ $t('input_forms.button.save') }}
  </UIBtn>
</template>

<style scoped>

</style>